import pluralize from "pluralize"

const actions = {
  //global
  async confirmDiscardChanges({dispatch}, {dontSaveAndContinue, saveAndContinue}) {
    dispatch('popups/show/confirm',{
      message: `Save changes?`,
      description: "If you don't save, your changes will be dismissed.",
      buttons: [
        {
          name: "Don't save",
          id: 'dont-save',
          function: dontSaveAndContinue,
        },
        {
          name: "Back to editing",
          id: 'back',
          function: 'close',
        },
        {
          name: 'Save',
          id: 'save',
          function: saveAndContinue,
          colour: 'green'
        }
      ],
    }, {root: true})
  },

  //customise
  async confirmSwitchSpaceType({dispatch}, [type, callback, saveCallback]) { //private/open space switch
    dispatch('popups/show/confirm',{
      message: `Are you sure you want <br> to switch to ${type === 'open' ? 'an Open Space' : 'a Private Space'}?`,
      description: `${type === 'open' ? 'Anyone can enter this Space.' : 'Only members can enter the Space. <br> All guest users will lose their access.'}`,
      buttons: [
        {
          name: 'Switch',
          id: 'save',
          function: () => {
            dispatch('popups/close', null, {root: true})
            saveCallback()
          },
          colour: 'green'
        },
        {
          name: "Cancel",
          id: 'back',
          function: () => {
            dispatch('popups/close', null, {root: true})
            callback()
          },
        },
      ],
    }, {root: true})
  },

  //manage users
  async errorAddEmailInvalid({dispatch},emails) {
    dispatch('popups/show/confirm',{
      icon: 'error',
      message: `${pluralize('Email', emails.length)} not valid: \n ${emails.join(', ')}`
    }, {root: true})
  },
  async errorAddEmailAlreadyAdded({dispatch},emails) {
    dispatch('popups/show/confirm',{
      icon: 'error',
      message: `${pluralize('Email', emails.length)} already added: \n ${emails.join(', ')}`
    }, {root: true})
  },
  async errorAddEmailInvalidAndAlreadyAdded({dispatch},emails) {
    dispatch('popups/show/confirm',{
      icon: 'error',
      message: `${pluralize('Email', emails.length)} not valid or already added: \n ${emails.join(', ')}`
    }, {root: true})
  },
  async errorInvitingUsersToArea({dispatch}) {
    dispatch('popups/show/confirm',{
      icon: 'error',
      message: `There was an error inviting users to this Space, you can try again from the Manage Users Page in Settings.`
    }, {root: true})
  },
  async errorInvitingConvertedGuestUsersToArea({dispatch}) {
    dispatch('popups/show/confirm',{
      icon: 'error',
      message: `Invite could not be resent. Email address of this user is unknown. <br><br> Please use the 'Invite new user(s)' button above instead.`
    }, {root: true})
  },
  async successInvitingUsersToArea({dispatch}, {validAdds, invalidAdds}) {
    let text = ''
    let icon = 'success'
    if (validAdds.length && !invalidAdds.length) {
      text = `Successfully invited ${validAdds.length} ${pluralize('user', validAdds.length)}. <br></br> They should receive an email shortly.`
    } else if (validAdds.length && invalidAdds.length) {
      text = `Successfully invited ${validAdds.length} ${pluralize('user', validAdds.length)}. <br></br> They should receive an email shortly.</br></br>
      However, ${invalidAdds.length} ${pluralize('user', invalidAdds.length)} already exists.`
    } else if (invalidAdds.length) {
      text = `These emails have already been added.`
      icon = 'error'
    }

    if(icon === 'success') {
      dispatch('popups/show/success', {
        message: text,
        timeout: 6000
      }, {root: true})
    } else {
      dispatch('popups/show/error', {
        message: text
      }, {root: true})
    }
  },
};

export default {
  namespaced: true,
  actions
};
